import React, { useMemo, useRef, useState, useEffect } from "react";
import LabelPrint from "../Print/LabelPrint";
import DocumentPrint from "../Print/DocumentPrint";
import { useDocument } from '../../utils/DocumentContext';

export default function WindowPrint({
  onClose,
  printData = [],
  documentData = null,
  positions = []
}) {
  const [activeTab, setActiveTab] = useState(0); // 0 - печать этикеток, 1 - печать документа
  const [isPrinting, setIsPrinting] = useState(false);
  const { selectedDocument, documentPositions, hasSelectedDocument } = useDocument();
  const printRef = useRef(null);

  // Используем переданные данные с приоритетом над контекстом
  const currentDocument = (documentData !== null && documentData !== undefined) ? documentData : selectedDocument;
  const currentPositions = positions.length > 0 ? positions : documentPositions;
  const hasDocument = (documentData !== null && documentData !== undefined) || hasSelectedDocument;

  console.log('WindowPrint: Выбор данных:', {
    documentData: !!documentData,
    selectedDocument: !!selectedDocument,
    currentDocument: !!currentDocument,
    positions: positions.length,
    documentPositions: documentPositions.length,
    currentPositions: currentPositions.length
  });

  console.log('WindowPrint: Детальная информация о документах:', {
    'documentData полный объект': documentData,
    'selectedDocument полный объект': selectedDocument,
    'documentData === null': documentData === null,
    'documentData !== null': documentData !== null,
    'positions массив': positions,
    'documentPositions массив': documentPositions
  });

  // Проверяем, что currentDocument действительно использует правильные данные
  console.log('WindowPrint: Результат выбора:', {
    'currentDocument использует documentData': currentDocument === documentData,
    'currentDocument использует selectedDocument': currentDocument === selectedDocument,
    'currentDocument номер': currentDocument?.ДокументНомер || currentDocument?.filename,
    'documentData номер': documentData?.ДокументНомер || documentData?.filename,
    'selectedDocument номер': selectedDocument?.ДокументНомер || selectedDocument?.filename
  });

  // Обработчик клавиши Escape для закрытия окна
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && !isPrinting) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, isPrinting]);
  // Функция печати
  const handlePrint = async () => {
    setIsPrinting(true);

    try {
      const printContent = printRef.current;
      if (!printContent) {
        alert('Помилка: зміст для друку не знайдено');
        setIsPrinting(false);
        return;
      }

      console.log('Print content for new window:', printContent.innerHTML);

      // Создаем новое окно для печати
      const printWindow = window.open('', '_blank', 'width=800,height=600,scrollbars=yes');

      if (!printWindow) {
        alert('Не удалось открыть окно печати. Проверьте настройки блокировщика всплывающих окон.');
        setIsPrinting(false);
        return;
      }

      // Получаем все стили из текущей страницы
      const allStyles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
        .map(style => {
          if (style.tagName === 'STYLE') {
            return `<style>${style.innerHTML}</style>`;
          } else {
            return `<link rel="stylesheet" href="${style.href}">`;
          }
        }).join('\n');

      // Формируем HTML для печати
      const printHTML = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Печать - ${activeTab === 0 ? 'Этикетки' : 'Документ'}</title>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          ${allStyles}
          <style>
            * { 
              margin: 0; 
              padding: 0; 
              box-sizing: border-box; 
              -webkit-print-color-adjust: exact !important; 
              print-color-adjust: exact !important; 
            }
            body { 
              font-family: Arial, sans-serif; 
              background: white; 
              color: black;
              line-height: 1.4;
            }
            @media print {
              body { margin: 0; }
              .no-print { display: none !important; }
            }
            @page {
              margin: ${activeTab === 0 ? '5mm' : '10mm'};
              size: A4;
            }
            .print-debug {
              border: 1px solid red;
              padding: 10px;
              margin: 10px 0;
              background: #f0f0f0;
            }
          </style>
        </head>
        <body>
          <div class="print-debug">
            <h3>Отладочная информация:</h3>
            <p>Активная вкладка: ${activeTab === 0 ? 'Этикетки' : 'Документ'}</p>
            <p>Размер содержимого: ${printContent.innerHTML.length} символов</p>
            <p>Время печати: ${new Date().toLocaleString()}</p>
          </div>
          <div id="print-content">
            ${printContent.innerHTML}
          </div>
          <script>
            console.log('Print window loaded');
            console.log('Content length:', document.getElementById('print-content').innerHTML.length);
          </script>
        </body>
        </html>
      `;

      // Записываем содержимое в новое окно
      printWindow.document.write(printHTML);
      printWindow.document.close();

      // Ждем загрузки и запускаем печать
      printWindow.onload = () => {
        console.log('Print window onload triggered');
        setTimeout(() => {
          try {            printWindow.print();
            // Не закрываем окно автоматически для отладки
            // printWindow.close();
          } catch (e) {
            console.error('Error printing:', e);
            alert('Помилка при друку: ' + e.message);
          }
        }, 1000);
      };

    } catch (error) {
      console.error('Помилка при друку:', error);
      alert('Сталася помилка при друку: ' + error.message);
    } finally {
      setIsPrinting(false);
    }
  };

  // Быстрая печать (использует window.print) - ПОЛНОСТЬЮ ИСПРАВЛЕННАЯ ВЕРСИЯ
  const handleQuickPrint = () => {
    setIsPrinting(true);

    try {
      const printContent = printRef.current;      if (!printContent) {
        alert('Помилка: зміст для друку не знайдено');
        setIsPrinting(false);
        return;
      }

      // Проверяем, есть ли содержимое
      console.log('Print content:', printContent);
      console.log('Print content HTML length:', printContent.innerHTML.length);

      if (!printContent.innerHTML.trim()) {
        alert('Предупреждение: содержимое для печати пустое');
        setIsPrinting(false);
        return;
      }

      // Создаем стили специально для печати
      const printStyles = document.createElement('style');
      printStyles.id = 'temp-print-styles';
      printStyles.innerHTML = `
        @media print {
          /* Скрываем всё кроме контента для печати */
          body > *:not(.print-content-wrapper) { 
            display: none !important; 
            visibility: hidden !important;
          }
          
          /* Показываем только контент для печати */
          .print-content-wrapper { 
            display: block !important; 
            visibility: visible !important;
            position: static !important;
            width: 100% !important;
            height: auto !important;
            overflow: visible !important;
            background: white !important;
            color: black !important;
            font-family: Arial, sans-serif !important;
            font-size: 12px !important;
          }
          
          /* Принудительно показываем все вложенные элементы */
          .print-content-wrapper * {
            visibility: visible !important;
            display: block !important;
            color: inherit !important;
            background-color: transparent !important;
          }
          
          /* Исключения для элементов которые должны быть inline */
          .print-content-wrapper span,
          .print-content-wrapper strong,
          .print-content-wrapper em,
          .print-content-wrapper b,
          .print-content-wrapper i {
            display: inline !important;
          }
          
          /* Стили для таблиц */
          .print-content-wrapper table {
            display: table !important;
            border-collapse: collapse !important;
            width: 100% !important;
          }
          
          .print-content-wrapper tr {
            display: table-row !important;
          }
          
          .print-content-wrapper td,
          .print-content-wrapper th {
            display: table-cell !important;
            border: 1px solid #000 !important;
            padding: 4px !important;
          }
          
          /* Стили для flex контейнеров */
          .print-content-wrapper .stats-grid,
          .print-content-wrapper .doc-info-grid,
          .print-content-wrapper .quantity-summary {
            display: block !important;
          }
          
          .print-content-wrapper .stat-card,
          .print-content-wrapper .info-item,
          .print-content-wrapper .qty-item {
            display: block !important;
            margin-bottom: 5px !important;
            border: 1px solid #ccc !important;
            padding: 5px !important;
          }
          
          /* Стили для вертикальной ленты этикеток */
          .print-content-wrapper .labels-vertical-tape-container {
            background: white !important;
            padding: 0 !important;
          }
          
          .print-content-wrapper .labels-vertical-tape {
            width: 100% !important;
            max-width: none !important;
            border: 1px solid #000 !important;
            box-shadow: none !important;
          }
          
          .print-content-wrapper .label-vertical-item {
            page-break-inside: avoid !important;
            border-bottom: 1px solid #000 !important;
            padding: 5mm !important;
          }
          
          /* Убираем перфорацию при печати */
          .print-content-wrapper .labels-vertical-tape::before,
          .print-content-wrapper .labels-vertical-tape::after {
            display: none !important;
          }
          
          /* Настройки страницы */
          @page {
            margin: ${activeTab === 0 ? '5mm' : '10mm'};
            size: A4;
          }
        }
      `;

      document.head.appendChild(printStyles);

      // Создаем wrapper для контента
      const wrapper = document.createElement('div');
      wrapper.className = 'print-content-wrapper';
      wrapper.style.display = 'none'; // Скрываем на экране
      wrapper.innerHTML = printContent.innerHTML;

      // Добавляем wrapper в body
      document.body.appendChild(wrapper);

      // Небольшая задержка для применения стилей
      setTimeout(() => {
        try {
          // Печатаем
          window.print();

          // Убираем wrapper и стили после печати
          setTimeout(() => {
            if (document.body.contains(wrapper)) {
              document.body.removeChild(wrapper);
            }
            if (document.head.contains(printStyles)) {
              document.head.removeChild(printStyles);
            }
          }, 100);        } catch (error) {
          console.error('Помилка при друку:', error);
          alert('Помилка при друку: ' + error.message);
        }
      }, 100);    } catch (error) {
      console.error('Помилка при швидкому друку:', error);
      alert('Сталася помилка при друку: ' + error.message);
    } finally {
      setTimeout(() => setIsPrinting(false), 200);
    }
  };

  // Экспорт в PDF (с помощью печати в PDF)
  const handleExportPDF = () => {
    setIsPrinting(true);

    try {
      const printWindow = window.open('', '_blank', 'width=800,height=600');

      if (!printWindow) {
        alert('Не удалось открыть окно для экспорта. Проверьте настройки браузера.');
        return;
      }      const printContent = printRef.current;
      if (!printContent) {
        alert('Помилка: зміст для експорту не знайдено');
        return;
      }

      const printHTML = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Экспорт в PDF - ${activeTab === 0 ? 'Этикетки' : 'Документ'}</title>
          <meta charset="utf-8">
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: Arial, sans-serif; background: white; }
            @page {
              margin: ${activeTab === 0 ? '5mm' : '10mm'};
              size: A4;
            }
          </style>
        </head>
        <body>
          <div style="padding: 10px; text-align: center; background: #f0f0f0; margin-bottom: 10px;">
            <strong>Для сохранения в PDF выберите "Сохранить как PDF" в настройках печати</strong>
          </div>
          ${printContent.innerHTML}
        </body>
        </html>
      `;

      printWindow.document.write(printHTML);
      printWindow.document.close();

      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print();
        }, 500);
      };    } catch (error) {
      console.error('Помилка при експорті в PDF:', error);
      alert('Сталася помилка при експорті: ' + error.message);
    } finally {
      setIsPrinting(false);
    }
  };

  // Подготавливаем данные для печати этикеток
  const prepareLabelData = () => {
    console.log('prepareLabelData: Начало функции', { hasDocument, currentPositions: currentPositions.length });

    if (hasDocument && currentPositions) {
      console.log('prepareLabelData: Используем данные документа', currentPositions);

      // ИЗМЕНЕНИЕ: показываем этикетки для всех позиций с планом > 0, а не только с фактом > 0
      const filteredPositions = currentPositions.filter(pos => {
        const plan = Number(pos.КоличествоПлан || pos.plan || 0);
        const fact = Number(pos.КоличествоФакт || pos.fact || 0);
        return plan > 0; // Показываем этикетки если есть план
      });

      console.log('prepareLabelData: Отфильтрованные позиции', filteredPositions);

      const labelData = filteredPositions.map(position => ({
        title: position.Наименование || position.name || 'Без названия',
        article: position.Код || position.article || position.id || '',
        brand: position.brand || '',
        category: position.category || '',
        subcategory: position.subcategory || '',
        purchaseDate: currentDocument?.ДокументДата ? new Date(currentDocument.ДокументДата).toLocaleDateString('ru-RU') : '',
        supplier: 'AlterAir',
        barcode: position.barcode || position.Код || position.article || position.id || '',
        quantity: Math.max(1, Number(position.КоличествоПлан || position.plan || 1)), // Используем план для количества этикеток
      }));

      console.log('prepareLabelData: Подготовленные данные для этикеток', labelData);
      return labelData;
    }

    // Если нет документа, используем переданные данные
    if (printData.length > 0) {
      console.log('prepareLabelData: Используем printData', printData);
      return printData.map(item => ({
        title: item.name || 'Без названия',
        article: item.article || '',
        brand: item.brand || '',
        category: item.category || '',
        subcategory: item.subcategory || '',
        purchaseDate: new Date().toLocaleDateString('ru-RU'),
        supplier: item.supplier || 'AlterAir',
        barcode: item.barcode || item.article || '',
        quantity: item.quantity || 1,
      }));
    }

    // Пример данных
    console.log('prepareLabelData: Используем примерные данные');
    return [
      {
        title: 'Образец товара',
        article: 'ART001',
        brand: 'AlterAir',
        category: 'Вентиляция',
        subcategory: 'Вентиляторы',
        purchaseDate: new Date().toLocaleDateString('ru-RU'),
        supplier: 'AlterAir',
        barcode: '1234567890123',
        quantity: 1,
      }
    ];
  };

  const tabs = [
    {
      label: '🏷️',
      title: 'Друк етикеток',
      disabled: false,
      description: hasDocument ?
        `Этикетки для документа: ${currentDocument?.ДокументНомер || currentDocument?.filename || 'Документ'}` :
        'Друк етикеток товарів'
    },
    {
      label: '📋',
      title: 'Друк документа',
      disabled: !hasDocument,
      description: hasDocument ?
        `Документ: ${currentDocument?.ДокументНомер || currentDocument?.filename || 'Документ'}` :
        'Оберіть документ для друку'
    }
  ];

  return (
    <div style={{
      position: 'fixed',
      top: '8px',
      left: '8px',
      right: '8px',
      bottom: '8px',
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 1000,
      border: '1px solid #ccc',
      borderRadius: '12px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.15)'
    }}>
      {/* Шапка с крестиком и кнопками печати */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 16px',
        backgroundColor: '#4caf50',
        color: 'white',
        borderBottom: '1px solid #e0e0e0',
        borderRadius: '12px 12px 0 0'
      }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
            🖨️ {tabs[activeTab].title}
          </h2>
          <div style={{ fontSize: '12px', opacity: 0.9, marginTop: '2px' }}>
            {tabs[activeTab].description}
          </div>        </div>

        {/* Кнопка закрытия */}
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: 'white',
            padding: '8px',
            borderRadius: '6px',
            minHeight: '40px',
            minWidth: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          ✕
        </button>      </div>

      {/* Панелька с кнопками печати */}
      <div style={{
        padding: window.innerWidth < 768 ? '8px 12px' : '12px 16px',
        borderBottom: '1px solid #e0e0e0',
        background: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        gap: window.innerWidth < 768 ? '8px' : '12px',
        flexWrap: window.innerWidth < 480 ? 'wrap' : 'nowrap'
      }}>
        <button
          onClick={handleQuickPrint}
          disabled={isPrinting}
          style={{
            background: 'white',
            border: '1px solid #4caf50',
            color: '#4caf50',
            padding: window.innerWidth < 768 ? '10px 16px' : '8px 16px',
            borderRadius: '6px',
            cursor: isPrinting ? 'not-allowed' : 'pointer',
            fontSize: window.innerWidth < 768 ? '14px' : '13px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            opacity: isPrinting ? 0.6 : 1,
            transition: 'all 0.2s',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            minWidth: window.innerWidth < 480 ? '100px' : 'auto',
            flex: window.innerWidth < 480 ? '1' : 'none',
            justifyContent: 'center'
          }}
          title="Швидкий друк"
          onMouseEnter={(e) => !isPrinting && (e.target.style.backgroundColor = '#e8f5e8')}
          onMouseLeave={(e) => !isPrinting && (e.target.style.backgroundColor = 'white')}
        >
          {isPrinting ? '⏳' : '🖨️'} 
          {window.innerWidth >= 380 && 'Друк'}
        </button>

        <button
          onClick={handlePrint}
          disabled={isPrinting}
          style={{
            background: 'white',
            border: '1px solid #2196f3',
            color: '#2196f3',
            padding: window.innerWidth < 768 ? '10px 16px' : '8px 16px',
            borderRadius: '6px',
            cursor: isPrinting ? 'not-allowed' : 'pointer',
            fontSize: window.innerWidth < 768 ? '14px' : '13px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            opacity: isPrinting ? 0.6 : 1,
            transition: 'all 0.2s',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            minWidth: window.innerWidth < 480 ? '100px' : 'auto',
            flex: window.innerWidth < 480 ? '1' : 'none',
            justifyContent: 'center'
          }}
          title="Друк у новому вікні"
          onMouseEnter={(e) => !isPrinting && (e.target.style.backgroundColor = '#e3f2fd')}
          onMouseLeave={(e) => !isPrinting && (e.target.style.backgroundColor = 'white')}
        >
          {isPrinting ? '⏳' : '📄'}
          {window.innerWidth >= 380 && 'Вікно'}
        </button>

        <button
          onClick={handleExportPDF}
          disabled={isPrinting}
          style={{
            background: 'white',
            border: '1px solid #ff9800',
            color: '#ff9800',
            padding: window.innerWidth < 768 ? '10px 16px' : '8px 16px',
            borderRadius: '6px',
            cursor: isPrinting ? 'not-allowed' : 'pointer',
            fontSize: window.innerWidth < 768 ? '14px' : '13px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            opacity: isPrinting ? 0.6 : 1,
            transition: 'all 0.2s',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            minWidth: window.innerWidth < 480 ? '100px' : 'auto',
            flex: window.innerWidth < 480 ? '1' : 'none',
            justifyContent: 'center'
          }}
          title="Експорт у PDF"
          onMouseEnter={(e) => !isPrinting && (e.target.style.backgroundColor = '#fff3e0')}
          onMouseLeave={(e) => !isPrinting && (e.target.style.backgroundColor = 'white')}
        >
          {isPrinting ? '⏳' : '📋'}
          {window.innerWidth >= 380 && 'PDF'}
        </button>
      </div>

      {/* Вкладки */}
      <div style={{
        display: 'flex',
        borderBottom: '1px solid #e0e0e0',
        backgroundColor: '#f5f5f5'
      }}>
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => !tab.disabled && setActiveTab(index)}
            disabled={tab.disabled}
            style={{
              flex: 1,
              padding: '16px 20px',
              border: 'none',
              background: activeTab === index ? '#fff' : 'transparent',
              color: tab.disabled ? '#ccc' : (activeTab === index ? '#4caf50' : '#666'),
              cursor: tab.disabled ? 'not-allowed' : 'pointer',
              fontSize: '16px',
              fontWeight: activeTab === index ? '600' : 'normal',
              borderBottom: activeTab === index ? '3px solid #4caf50' : '3px solid transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              transition: 'all 0.2s'
            }}
          >
            <span style={{ fontSize: '20px' }}>{tab.label}</span>
            {tab.title}
          </button>
        ))}
      </div>      {/* Контент для печати */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        overflow: 'hidden'
      }}>
        <div ref={printRef} style={{ 
          flex: 1, 
          overflow: activeTab === 0 ? 'auto' : 'auto',
          height: '100%'
        }}>
          {activeTab === 0 && (
            // Печать этикеток
            <LabelPrint items={prepareLabelData()} containerMode="embedded" />
          )}

          {activeTab === 1 && hasDocument && (
            // Печать документа
            <DocumentPrint
              document={currentDocument}
              positions={currentPositions}
            />
          )}

          {activeTab === 1 && !hasDocument && (
            // Сообщение о необходимости выбрать документ
            <div style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              background: '#f9f9f9',
              margin: '16px',
              borderRadius: '8px',
              border: '2px dashed #ccc',
              padding: '32px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '64px', marginBottom: '16px', opacity: 0.5 }}>📄</div>              <h3 style={{ margin: '0 0 8px 0', color: '#666' }}>Документ не обрано</h3>
              <p style={{ margin: 0, color: '#999', fontSize: '14px' }}>
                Перейдіть на вкладку "Пакети даних" і оберіть документ для друку
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
